import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
================================================================================ */

export default function MenuItems4() {
    let history = useHistory();
    const items = [
        {
            label: 'Usuarios Autogestión', index: 0,
            path: "/Users",
        },
        {
            label: 'Gestión de contraseña', index: 1,
            path: "/Password_management",
        }
    ]
    return items
}